import { combineReducers } from 'redux';
import { LOGIN_SUCCESS, LOGIN_FAILURE, SET_USER, SET_DATA } from '../actions';
import { FETCH_MACHINES_REQUEST, FETCH_MACHINES_SUCCESS, FETCH_MACHINES_FAILURE, FETCH_ORDERS_REQUEST, FETCH_ORDERS_SUCCESS, FETCH_ORDERS_FAILURE, FETCH_TASKTYPE_SUCCESS } from '../actions';
import { SET_ACCESS_PERMISSIONS } from '../actions';
import { SELECT_SUBMENU } from '../actions';

const initialState = {
  selectedSubMenu: '',
  data: '',
};

const menuReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECT_SUBMENU:
      return {
        ...state,
        selectedSubMenu: action.payload,
      };

    case SET_DATA:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

const initialStateUser = {
  user: null,
  error: null,
  isAuthenticated: false,
};

const authReducer = (state = initialStateUser, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: true,
        error: null,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        user: null,
        isAuthenticated: false,
        error: action.payload,
      };
    case SET_USER:
      return {
        ...state,
        user: action.payload,
        isAuthenticated: !!action.payload, // Autenticado si existe el usuario
      };
    default:
      return state;
  }
};

const initialStateMachine = {
  loading: false,
  machines: [],
  orders: [],
  error: '',
  taskType: [],
};

const machineReducer = (state = initialStateMachine, action) => {
  switch (action.type) {
    case FETCH_MACHINES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_MACHINES_SUCCESS:
      return {
        ...state,
        loading: false,
        machines: action.payload,
      };
    case FETCH_MACHINES_FAILURE:
      return {
        ...state,
        machines: [],
        loading: false,
        error: action.payload,
      };
    case FETCH_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload,
      };
    case FETCH_ORDERS_FAILURE:
      return {
        ...state,
        orders: [],
        loading: false,
        error: action.payload,
      };
    case FETCH_TASKTYPE_SUCCESS:
      return {
        ...state,
        taskType: action.payload,
      };
    default:
      return state;
  }
};

const initialStateAccess = {
  permissions: [],
};

const accessReducer = (state = initialStateAccess, action) => {
  switch (action.type) {
    case SET_ACCESS_PERMISSIONS:
      return {
        ...state,
        permissions: action.payload,
      };
    default:
      return state;
  }
};

// Combinar los reducers
const rootReducer = combineReducers({
  auth: authReducer,
  machine: machineReducer,
  access: accessReducer,
  menu: menuReducer,
});

export default rootReducer;
